import React from "react";
import { createPortal } from "react-dom";

export default function ClientScheduleNoteModal({ modal, onClose }) {
  if (!modal) return null;

  const content = (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 z-[50300] flex items-center justify-center p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-sm p-4"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <h3 className="text-base font-semibold mb-3">
          {modal.type === "temp" ? "Note to Temp Staff" : "Admin Note"}
        </h3>
        <div className="mb-4 text-sm text-gray-800 whitespace-pre-line">
          {modal.type === "temp"
            ? modal.tempText || "No note for temp staff."
            : modal.adminText || "No admin note."}
        </div>
        <div className="flex justify-end">
          <button
            type="button"
            className="px-4 py-1.5 text-sm border rounded hover:bg-gray-100"
            onClick={onClose}
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );

  if (typeof document !== "undefined") {
    return createPortal(content, document.body);
  }
  return content;
}
